import { useEffect, useState } from "react";
import { MdLogout } from "react-icons/md";
import { useMsal } from "@azure/msal-react";
import { NavLink } from "@mantine/core";
import { useAuthContext } from "../../loginContext";
import { checkLoggedIn, getUsername } from "../../authConfig";

export const Logout = () => {
    const { instance } = useMsal();
    const { logout, login } = useAuthContext();
    const activeAccount = instance.getActiveAccount();
    const [username, setUsername] = useState("");

    useEffect(() => {
        const fetchUsername = async () => {
            setUsername((await getUsername(instance)) ?? "");
        };

        fetchUsername();
    }, []);

    const handleLogoutPopup = () => {
        if (activeAccount) {
            instance
                .logoutPopup({
                    mainWindowRedirectUri: "/", // redirects the top level app after logout
                    account: instance.getActiveAccount()
                })
                .catch(error => console.log(error))
                .then(async () => {
                    const test = await checkLoggedIn(instance);
                    if (test) {
                        login();
                    } else {
                        logout();
                    }
                    setUsername((await getUsername(instance)) ?? "");
                });
        }
    };

    return (
        <NavLink
            key="Logout"
            label={username}
            rightSection={<MdLogout size={24} color="var(--mantine-color-red-6)" />}
            onClick={handleLogoutPopup}
            color="blue.6"
            variant="subtle"
            autoContrast
        />
    );
};
